import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import '../../style/Dropdown.less';

function Dropdown(props) {
    const isMulti = Array.isArray(props.value);
    const [t] = useTranslation();

    function getSelectedValue(isMultiVal, useRawValue = props.useRawValue ? props.useRawValue : false) {
        if (!props.value) {
            return null;
        }
        if (!isMultiVal) {
            if (useRawValue) {
                return props.value;
            }
            return props.options.find(option => {
                if (props.valueCompareFunction) {
                    return props.valueCompareFunction(option.value, props.value.value);
                }
                return option.value === props.value.value;
            });
        } else {
            const selectedValue = [];
            for (const key in props.options) {
                for (const selectedKey in props.value) {
                    if (props.value.hasOwnProperty(selectedKey) && props.options[key].value === props.value[selectedKey].value) {
                        selectedValue.push(props.options[key]);
                    }
                }
            }
            return selectedValue;
        }
    }

    function onChange(value) {
        if (props.onChange) {
            if (isMulti) {
                props.onChange(value || []);
            } else {
                props.onChange(value);
            }
        }
    }

    return (
        <div className="form-group">
            {
                props.label &&
                <label>{`${props.label} ${props.required ? '*' : ''}`}</label>
            }
            <Select
                className={props.isValid === false ? 'is-invalid' : null}
                classNamePrefix="dropdown"
                options={props.options}
                placeholder={props.placeholder ? props.placeholder : t('Common.PLEASE_SELECT')}
                isClearable={props.isClearable}
                onChange={onChange}
                value={getSelectedValue(isMulti)}
                isMulti={isMulti}
                closeMenuOnSelect={!isMulti}
                noOptionsMessage={() => t('Common.NO_OPTIONS')}
                isDisabled={props.isDisabled ? props.isDisabled : false}
                tabIndex={props.tabIndex}
            >
            </Select>
            {
                props.isValid === false &&
                <div className="invalid-feedback">
                    {t('Validation.REQUIRED')}
                </div>
            }
        </div>
    );
}

Dropdown.propTypes = {
    options: PropTypes.array,
    placeholder: PropTypes.string,
    isClearable: PropTypes.bool,
    isValid: PropTypes.bool,
    isDisabled: PropTypes.bool,
    onChange: PropTypes.func,
    valueCompareFunction: PropTypes.func,
    value: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
        PropTypes.string
    ])
};

export default Dropdown;
